<form [formGroup]="budgetAndAlertsForm">

  <!-- SELECT SCOPE -->
  <ng-container>
    <div>
      <div style="display: flex;">
        <h6>SELECT SCOPE</h6>
        <app-refresh-button
          *ngIf="scopeList?.length"
          style="margin-left: auto;"
          [spinnerRotate]="refreshing"
          (refreshCallBack)="refresh()"
        ></app-refresh-button>
      </div>
      <div style="display: inline-flex;">
        <mat-form-field style="padding-left: 0px; " *ngIf="scopeList?.length">
          <mat-select formControlName="scope" (selectionChange)="switchScope($event)" [disableControl]="!scopeList?.length || loading">
            <mat-option *ngFor="let s of scopeList" [value]="s.value">
              {{s.id}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-spinner
          *ngIf="!scopeList?.length || loading"
          mode="indeterminate"
          class="circle"
          diameter="20"
          style="margin: auto 40px;"
        >
        </mat-spinner>
      </div>
    </div>
  </ng-container>

  <!-- BUDGET & ALERTS -->
  <ng-container *ngIf="scopeList?.length && !loading">
    <div class="my-4">
      <div style="display: flex;">
        <h6>BUDGET & ALERTS</h6>
        <button
          class="button button-red button-round"
          style="margin-left: auto;"
          (click)="createBudget()"
        >
          &nbsp;Create&nbsp;
        </button>
      </div>
      <div class="my-4">
        <table mat-table [dataSource]="budgetTableDataSrc" *ngIf="budgetTableDataSrc?.length > 0 && !loading">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef width="24%">Name</th>
            <td mat-cell *matCellDef="let element">
              <span class="link-for-click" (click)="budgetAlertsDetailView(element)">{{ element.name }}</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="resetPeriod">
            <th mat-header-cell *matHeaderCellDef width="12%">Reset Period</th>
            <td mat-cell *matCellDef="let element"> {{element.resetPeriod}} </td>
          </ng-container>

          <ng-container matColumnDef="createDate">
            <th mat-header-cell *matHeaderCellDef width="12%">Create Date</th>
            <td mat-cell *matCellDef="let element">{{ element.createDate | date:'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="expDate">
            <th mat-header-cell *matHeaderCellDef width="12%">Exp Date</th>
            <td mat-cell *matCellDef="let element">{{ element.expDate | date:'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="budget">
            <th mat-header-cell *matHeaderCellDef width="12%">Budget</th>
            <td mat-cell *matCellDef="let element"> {{element.budget | currency:'AUD':'symbol-narrow':'.2-2'}} </td>
          </ng-container>

          <ng-container matColumnDef="currentSpend">
            <th mat-header-cell *matHeaderCellDef width="12%">Current Spend</th>
            <td mat-cell *matCellDef="let element"> {{element.currentSpend}} </td>
          </ng-container>

          <ng-container matColumnDef="progress">
            <th mat-header-cell *matHeaderCellDef width="12%" class="align-center">Progress</th>
            <td mat-cell *matCellDef="let element" class="align-center"> {{ element.progress | percent:'1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="delete">
            <th mat-header-cell *matHeaderCellDef width="6%" class="align-center"></th>
            <td mat-cell *matCellDef="let element" class="align-center">
              <button
                class="button button-red button-round"
                (click)="deleteBudget(element.name)"
              >
                &nbsp;Delete&nbsp;
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <label class="noData-wrapper" *ngIf="!budgetTableDataSrc?.length" style="height: 160px !important;">
          No budgets found for this subscription.
        </label>
      </div>

    </div>

  </ng-container>

</form>

